import { ref, computed, watch } from '@vue/composition-api'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment-timezone'
import store from '@/store'
import ability from '@/libs/acl/ability'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  const refListTable = ref(null)

  const toast = useToast()

  const tableColumns = [
    { label: 'ID', key: 'id', sortable: false },
    { label: 'municipality.name', key: 'name', sortable: false },
    { label: 'municipality.acronym', key: 'acronym', sortable: false },
    { label: 'region.title', key: 'region.name', sortable: false },
    { label: 'date.created_at', key: 'created_at', sortable: true, formatter: 'formatDateAssigned' },
    { label: 'date.updated_at', key: 'updated_at', sortable: true, formatter: 'formatDateAssigned' },
  ]

  if (ability.can('update', 'Municipality') == true || ability.can('delete', 'Municipality') == true) {
    tableColumns.splice(0, 0, { label: 'actions.name', key: 'actions' })
  }

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)

  const activeFilter = ref('1');

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  store.dispatch('region/getAll')
  const regionOptions = computed(() => store.getters['region/getSelectedItems'])
  const regionFilter = ref(null)

  const fetchList = (ctx, callback) => {

    store.dispatch('municipality/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      region: regionFilter.value,
    })
    .then(response => {
      callback(response.data)
      totalList.value = response.meta.total
    })
    .catch(() => {
      toast({
        component: ToastificationContent,
        props: {
          title: 'Error obteniendo la información',
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    })
  }

  const formatDateAssigned = value => {
    const formattedDate = moment(value).format('DD/MM/YYYY HH:mm:ss')
    return formattedDate
  }

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage ], () => {
    refetchData()
  })

  watch([ searchQuery ], debounce(() => {
    refetchData()
  }, 500))

    // filters counter ============================
    const filters = ref({});
    const filtersCount = useFilterCounter(filters);
    const buildFilters = () => {
      filters.value = {
        region: regionFilter.value,
      };
      refetchData();
    }
    const clearSearchFilters = () => {
      regionFilter.value = null;
      buildFilters();
    }
    // ============================================

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    formatDateAssigned,
    regionOptions,
    regionFilter,
    refetchData,

    filtersCount,
    buildFilters,
    clearSearchFilters,
  }
}
